import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone/moment-timezone';

@Pipe({
  name: 'parseTimezones'
})
export class ParseTimezonesPipe implements PipeTransform {

  transform(items: any[]): any[] {
    return items ? items.map(zone => {
      const zoneParts = zone.split('|');
      const name = zoneParts[0];
      const value = name.split("/")[1].replace("_", " ");
      const abbreviatedName = moment.tz(name)._z.abbr(new Date());;
      const abbreviations = zoneParts[1].split(" ") || zoneParts[1].split("/");
      return({
          name: name,
          value: value,
          abbreviations: abbreviations,
          abbreviatedName: abbreviatedName || value
      })
    }) : []
  }

}
